import { styled } from '@/shared/ui';

export const StyledChannelCardBox = styled('div')<{
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
}>(({ theme, variant = 'primary', disabled = false }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  borderRadius: '16px',
  border: `1px solid ${theme.palette.grey['300']}`,
  background: theme.palette.common.white,
  height: '150px',
  minWidth: '150px',
  width: '100%',
  cursor: 'pointer',
  transition: 'all 0.2s',
  padding: '24px',

  ...(variant === 'primary' && {
    alignItems: 'center',
  }),

  ...(variant === 'secondary' && {
    alignItems: 'flex-start',
  }),

  '&:hover': {
    ...(disabled
      ? {}
      : {
          boxShadow: '0px 6px 12px -6px rgba(0, 0, 0, 0.14)',
        }),
  },

  '&:active': {
    ...(disabled
      ? {
          border: `1px solid ${theme.palette.grey['300']}`,
        }
      : {
          border: `1px solid ${theme.palette.primary.main}`,
        }),
  },

  ...(disabled && {
    opacity: 0.5,
    cursor: 'not-allowed',
  }),
}));

export const IconContainer = styled('div')<{
  variant?: 'primary' | 'secondary';
}>(({ variant = 'primary' }) => ({
  width: 'fit-content',
  minWidth: '40px',
  height: '40px',
  fontSize: '40px',
  marginBottom: variant === 'primary' ? '7px' : '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const ComingSoonOverlay = styled('div')<{ disabled?: boolean }>(
  ({ theme, disabled = false }) => ({
    position: 'absolute',
    top: '20px',
    right: '20px',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    padding: '4px 16px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: '600',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    zIndex: 1,
    opacity: disabled ? 1 : 0,
    pointerEvents: 'none',
    transition: 'opacity 0.2s',
  })
);
